import { Box, Skeleton } from '@machobear/design-system'
import { skeletonStyle } from './chat-card-skeleton.css'

export const ChatCardSkeleton = () => {
  return (
    <Box
      position="relative"
      display="flex"
      justifyContent="spaceBetween"
      alignItems="center"
      cursor="pointer"
      zIndex={2}
      className={skeletonStyle}
    >
      <Box height="full">
        <Skeleton.Shape width={32} height={32} borderRadius="circle" />
      </Box>
      <Box display="flex" flexDirection="column" width="full">
        <Box paddingBottom={'xxsmall'} display="flex" flexDirection="column" paddingX="xsmall">
          <Skeleton.Header />
        </Box>
        <Box display="flex" flexDirection="column" width="full" paddingX={'xsmall'} height="full">
          <Skeleton.Text lineCount={2} />
        </Box>
      </Box>
      <Box style={{ alignSelf: 'flex-start' }} height="full" display="flex">
        <Skeleton.Shape width={56} height={24} />
      </Box>
    </Box>
  )
}
